import { render, staticRenderFns } from "./Rights.vue?vue&type=template&id=74924936&scoped=true&"
import script from "./Rights.vue?vue&type=script&lang=js&"
export * from "./Rights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74924936",
  null
  
)

export default component.exports